import Back from './Back'
import Cubeui from './Cubeui'
import FileDownload from './FileDownload'
import ListA from './ListA'
import NoInfo from './NoInfo'
import PdfView from './PdfView'
import ProgressBar from './ProgressBar'
import ProgressItem from './ProgressItem'
import RightHover from './RightHover'
import SelectModel from './SelectModel'
import SideBar from './SideBar'
import SwipeItem from './SwipeItem'
import TabBar from './TabBar'
import UploadComponent from './UploadComponent'
import UploadComponentClaim from './UploadComponentClaim'
import VeriCodeInput from './VeriCodeInput'
import Commonprogress from './Commonprogress'
import signature from './Signature'
import Skeleton from './Skeleton'
import Swiper from './Swiper'
import Skeleton2 from './Skeleton2'
let components = [
  Back,
  Cubeui,
  FileDownload,
  ListA,
  NoInfo,
  PdfView,
  ProgressBar,
  ProgressItem,
  RightHover,
  SelectModel,
  SideBar,
  SwipeItem,
  TabBar,
  UploadComponent,
  UploadComponentClaim,
  VeriCodeInput,
  Commonprogress,
  signature,
  Skeleton,
  Swiper,
  Skeleton2
]
export default () => {
  components.forEach((item) => {
    item()
  })
}
